import { reduxKey } from './constants';
function getCommentsThreadState(state) {
    return state[reduxKey] || { threads: {} };
}
export function getIsCommentsThreadInFeedOpen(state, streamId) {
    var _a, _b;
    return (_b = (_a = getCommentsThreadState(state).threads[streamId]) === null || _a === void 0 ? void 0 : _a.isOpen) !== null && _b !== void 0 ? _b : false;
}
//# sourceMappingURL=selectors.js.map